import {useTranslation} from 'react-i18next'
import {useMemo} from 'react'

export function useNamespaceTranslations(namespace) {
    const {t} = useTranslation(namespace)

    return useMemo(() => new Proxy({}, {
        get(_, key) {
            if (typeof key !== 'string') return undefined
            const value = t(key, {returnObjects: true})
            return value === key ? key : value
        }
    }), [t, namespace])
}
